import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';

import { CapacityResponse } from 'RestAPIs/roster/formation';

import {
  grossNetViewAtom,
  selectedCostCenterAtom,
  selectedFunctionAtom
} from '../../atoms';

import {
  Box,
  Chip,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography
} from '@mui/material';

import {
  SettingsChipContainer,
  SettingsPopper,
  StyledSettingsSection
} from 'components/shared/Settings';

import { VIEW } from '../../const';
import FormationFilters from './FormationFilters';

type View = typeof VIEW.GROSS | typeof VIEW.NET;

interface FormationViewSettingsProps {
  capacity?: CapacityResponse;
}

const FormationViewSettings = ({ capacity }: FormationViewSettingsProps) => {
  const { t } = useTranslation('common');
  const [selectedFunction, setSelectedFunction] =
    useRecoilState(selectedFunctionAtom);
  const [selectedCostCenter, setSelectedCostCenter] = useRecoilState(
    selectedCostCenterAtom
  );
  const [view, setView] = useRecoilState(grossNetViewAtom);

  const onChangeView = (e: SelectChangeEvent) => {
    setView(e.target.value as View);
  };

  return (
    <StyledSettingsSection>
      <SettingsChipContainer mb={4}>
        {selectedFunction && (
          <Chip
            size="small"
            label={`${t('function')}: ${selectedFunction.description}`}
            onDelete={() => setSelectedFunction(null)}
          />
        )}
        {selectedCostCenter && (
          <Chip
            size="small"
            label={`${t('planUnit')}: ${selectedCostCenter.nameShort}`}
            onDelete={() => setSelectedCostCenter(null)}
          />
        )}
      </SettingsChipContainer>
      <SettingsPopper>
        <Grid container spacing={3}>
          <Grid item xs={6} minWidth={250}>
            <FormationFilters capacity={capacity} />
          </Grid>
          <Grid item xs={6} minWidth={250}>
            <Typography variant="h3" mb={3}>
              {t('view')}
            </Typography>
            <Box pt="6px">
              <Select
                value={view}
                onChange={onChangeView}
                label={t('formationInGraph')}
                fullWidth
                sx={{ marginTop: '10px' }}
              >
                <MenuItem key={VIEW.GROSS} value={VIEW.GROSS}>
                  {t('grossFormation')}
                </MenuItem>
                <MenuItem key={VIEW.NET} value={VIEW.NET}>
                  {t('netFormation')}
                </MenuItem>
              </Select>
            </Box>
          </Grid>
        </Grid>
      </SettingsPopper>
    </StyledSettingsSection>
  );
};

export default FormationViewSettings;
